import { cDatabaseApi, cDbQuery } from "./DatabaseApi";

export class cProjectApi {
  private static _projects: Map<string,string>[] = [];

  public static async initProjectApi() {
    cDatabaseApi.initDatabaseApi("Project");
  }

  public static async fetchProjects(organization: string) {
    const q = new cDbQuery("Project");
    q.setWhere("Organization", organization);
    const dbRows = await cDatabaseApi.query(q);
    while(dbRows.next()){
      const rowMap: Map<string,string> = new Map();
      rowMap.set("Organization", dbRows.getProperty("Organization"));
      rowMap.set("ProjectName", dbRows.getProperty("ProjectName"));
      rowMap.set("ProjectId", dbRows.getProperty("ProjectId"));

      this._projects.push(rowMap);
    }
  }

  public static async getProjects(organization: string) {
    if (this._projects.length === 0) {
      await this.fetchProjects(organization);
      return this._projects;
    }
    return this._projects;
  }
}